import React from 'react';
import { IconProps } from '../IconProps';

const SvgHeadphonesWithMicrophone = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 17 16" {...props}>
    <g
      stroke={primaryColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.143}
    >
      <path d="M3.928 8V4.994A4.492 4.492 0 0 1 8.5.57v0a4.491 4.491 0 0 1 4.571 4.423V8" />
      <path d="M2.214 6.285h1.143a.571.571 0 0 1 .571.572v3.428a.571.571 0 0 1-.571.572H2.214a1.143 1.143 0 0 1-1.143-1.143V7.428a1.143 1.143 0 0 1 1.143-1.143v0zm12.571 4.571h-1.143a.572.572 0 0 1-.57-.571V6.856a.572.572 0 0 1 .57-.571h1.143a1.143 1.143 0 0 1 1.143 1.143v2.286a1.143 1.143 0 0 1-1.143 1.142v0zM10.786 14a2.286 2.286 0 0 0 2.285-2.286V9.143M10.786 14a1.429 1.429 0 0 1-1.429 1.428H7.643a1.429 1.429 0 1 1 0-2.857h1.714A1.429 1.429 0 0 1 10.786 14z" />
    </g>
  </svg>
);

export default SvgHeadphonesWithMicrophone;
